import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationItemComponent } from './notification-item/notification-item.component';
import {ApplicationPipesModule} from "../../application-pipes-module/application-pipes.module";
import {UserNotificationService} from "./user-notification.service";

@NgModule({
  imports: [
    CommonModule,
    ApplicationPipesModule
  ],
  declarations: [NotificationItemComponent],
  exports: [NotificationItemComponent],
  providers: [UserNotificationService]
})
export class NotificationModule { }
